import { useEffect, useRef, useState } from "react";
import { Building2, X } from "lucide-react";

const PLACEMENTS = [
  { id: "none", label: "Colors only" },
  { id: "left", label: "Left chest" },
  { id: "center", label: "Center chest" },
  { id: "right", label: "Right chest" },
];

// Optional company logo: its brand colours drive the outfit, and the mark can be printed on the chest.
export const LogoUploader = ({ logo, placement, onLogo, onPlacement }) => {
  const inputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!logo) return setPreview(null);
    const url = URL.createObjectURL(logo);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [logo]);

  return (
    <div data-testid="logo-uploader">
      <p className="text-xs font-mono2 font-bold uppercase tracking-widest text-accent mb-3">Company logo (optional)</p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid="logo-upload-btn"
          onClick={() => inputRef.current?.click()}
          className="h-14 w-14 shrink-0 rounded-2xl border-2 border-dashed border-border bg-background grid place-items-center overflow-hidden hover:border-primary transition-colors"
        >
          {preview ? <img src={preview} alt="logo" className="h-full w-full object-contain p-1" /> : <Building2 className="h-5 w-5 text-muted-foreground" />}
        </button>
        <input ref={inputRef} data-testid="logo-input" type="file" accept="image/*" className="hidden" onChange={(e) => onLogo(e.target.files?.[0] || null)} />
        <div className="flex-1 min-w-0">
          {logo ? (
            <>
              <p data-testid="logo-filename" className="text-sm font-semibold truncate">{logo.name}</p>
              <button type="button" data-testid="logo-remove-btn" onClick={() => onLogo(null)} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-destructive">
                <X className="h-3 w-3" /> Remove logo
              </button>
            </>
          ) : (
            <p className="text-xs text-muted-foreground">Brand colours become the outfit colours. Optionally print the mark on the chest.</p>
          )}
        </div>
      </div>
      {logo && (
        <>
          <div className="grid grid-cols-4 gap-2 mt-3">
            {PLACEMENTS.map((p) => (
              <button
                key={p.id}
                type="button"
                data-testid={`logo-placement-${p.id}`}
                onClick={() => onPlacement(p.id)}
                className={`rounded-full py-2 text-xs font-semibold border transition-colors ${
                  placement === p.id ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
                }`}
              >
                {p.label}
              </button>
            ))}
          </div>
          <p className="text-[11px] text-muted-foreground mt-2">Left / right are the wearer's sides, like a polo crest.</p>
        </>
      )}
    </div>
  );
};
